/**
 * Parse jwplayer url for mediaID & playerID.
 *
 * @param {string} src
 * @returns {object}
 */
export function parseEmbedSrc(src = '') {
  const REGEX = /https:\/\/.*\.jwplayer.com\/players\/(?<mediaID>\w+)-(?<playerID>\w+)/;
  const [, mediaID, playerID] = src.match(REGEX);
  return { mediaID, playerID };
}

/**
 * Parse data-jw-parameters on element.
 *
 * @param {Element} el
 * @returns {URLSearchParams}
 */
export function parsePlaceHolder(el) {
  const paramsString = el.getAttribute('data-jw-parameters');
  const params = new URLSearchParams(paramsString);
  return params;
}
